module.exports = __webpack_public_path__ + "img/fg_workcard.751d4cad.png";